// Catalogue JENMA Concept : matériaux nobles, rubriques et modules (dimensions en mm)

export const MAT = {
  noyer: { label: 'Noyer américain', kind: 'wood', c: '#5c3b25', c2: '#3e2617' },
  chene_fume: { label: 'Chêne fumé', kind: 'wood', c: '#6f5a46', c2: '#4b3b2c' },
  chene: { label: 'Chêne naturel', kind: 'wood', c: '#b9966b', c2: '#8f6f49' },
  teck: { label: 'Teck huilé', kind: 'wood', c: '#9a6a3c', c2: '#6e4724' },
  ebene: { label: 'Ébène de Macassar', kind: 'wood', c: '#3a2a20', c2: '#17100b' },
  laque_anthracite: { label: 'Laque anthracite mat', kind: 'lacquer', c: '#2e3033', c2: '#24262a' },
  laque_blanc: { label: 'Laque blanc cassé', kind: 'lacquer', c: '#ebe7df', c2: '#ddd7cc' },
  laque_greige: { label: 'Laque grège', kind: 'lacquer', c: '#bdb3a5', c2: '#a99e8f' },
  vert_foret: { label: 'Vert forêt profond', kind: 'lacquer', c: '#2f4a3e', c2: '#253c32' },
  bleu_nuit: { label: 'Bleu nuit', kind: 'lacquer', c: '#1f2a3a', c2: '#18202d' },
  fenix_noir: { label: 'Fenix noir velours', kind: 'lacquer', c: '#1c1c1d', c2: '#141415', matte: true },
  laque_sauge: { label: 'Sauge poudrée', kind: 'lacquer', c: '#9aa58e', c2: '#87927b', matte: true },
  laque_caramel: { label: 'Caramel satiné', kind: 'lacquer', c: '#a8754a', c2: '#8f623c' },
  laque_cachemire: { label: 'Cachemire velours', kind: 'lacquer', c: '#cbbba6', c2: '#b8a790', matte: true },
  laque_terracotta: { label: 'Terre cuite', kind: 'lacquer', c: '#a85f45', c2: '#8e4f38', matte: true },
  laque_marine: { label: 'Marine profond', kind: 'lacquer', c: '#26344a', c2: '#1d293b' },
  laque_lin: { label: 'Lin naturel', kind: 'lacquer', c: '#ddd3c2', c2: '#cbbfab', matte: true },
  chene_blanchi: { label: 'Chêne blanchi', kind: 'wood', c: '#d8c8ae', c2: '#bba98c' },
  chene_cognac: { label: 'Chêne cognac', kind: 'wood', c: '#8a5a33', c2: '#6a4224' },
  calacatta: { label: 'Marbre Calacatta Oro', kind: 'marble', c: '#f2eee7', c2: '#b9a27e' },
  nero: { label: 'Marbre Nero Marquina', kind: 'marble', c: '#1d1d1f', c2: '#d8d4cc' },
  vert_guatemala: { label: 'Marbre Verde Guatemala', kind: 'marble', c: '#2b4a3c', c2: '#cfe0d4' },
  travertin: { label: 'Travertin ivoire', kind: 'stone', c: '#dcc9a9', c2: '#bfa985' },
  quartzite: { label: 'Quartzite Taj Mahal', kind: 'marble', c: '#e7dbc6', c2: '#c4ab84' },
  beton: { label: 'Béton ciré', kind: 'stone', c: '#9d9a95', c2: '#85827d' },
  granit: { label: 'Granit noir absolu', kind: 'stone', c: '#2a2a2b', c2: '#3c3c3e' },
  marbre_creme: { label: 'Marbre crème latté', kind: 'marble', c: '#e6d8c3', c2: '#a88f6c' },
  terrazzo: { label: 'Terrazzo JENMA', kind: 'stone', c: '#e4ddd2', c2: '#9b8f80', speck: true },
  fenix_top: { label: 'Fenix anthracite', kind: 'stone', c: '#3a3b3c', c2: '#333435' },
  chene_massif: { label: 'Chêne massif huilé', kind: 'wood', c: '#b48a5c', c2: '#8d6740' },
  laiton: { label: 'Laiton brossé', kind: 'metal', c: '#b08d57', c2: '#e3c792' },
  bronze: { label: 'Bronze fumé', kind: 'metal', c: '#6b5232', c2: '#9c7b4f' },
  noir_mat: { label: 'Noir mat', kind: 'metal', c: '#1a1a1a', c2: '#4a4a4a' },
  inox: { label: 'Inox brossé', kind: 'metal', c: '#b9bbbd', c2: '#eceeef' },
  champagne: { label: 'Or champagne', kind: 'metal', c: '#cdb68a', c2: '#f1e2bf' },
  parquet_chene: { label: 'Parquet chêne clair', kind: 'floor-wood', c: '#c9ab82', c2: '#a88a62' },
  parquet_noir: { label: 'Parquet chêne noir', kind: 'floor-wood', c: '#262220', c2: '#3a3430' },
  parquet_fume: { label: 'Parquet chêne fumé', kind: 'floor-wood', c: '#7a6450', c2: '#5d4a3a' },
  sol_travertin: { label: 'Dalles travertin', kind: 'floor-stone', c: '#d8c6a6', c2: '#bba987' },
  sol_beton: { label: 'Béton ciré', kind: 'floor-stone', c: '#8f8c87', c2: '#7a7772' },
  sol_marbre: { label: 'Marbre Calacatta', kind: 'floor-stone', c: '#ece7de', c2: '#c7b597' },
  deck_teck: { label: 'Deck teck', kind: 'floor-wood', c: '#8e6340', c2: '#6c4a2e' },
  mur_blanc: { label: 'Blanc cassé', kind: 'paint', c: '#f1eee8' },
  mur_greige: { label: 'Grège', kind: 'paint', c: '#d6cdc0' },
  mur_anthracite: { label: 'Anthracite', kind: 'paint', c: '#3a3b3d' },
  mur_terracotta: { label: 'Terracotta douce', kind: 'paint', c: '#c69c83' },
  mur_olive: { label: 'Vert olive', kind: 'paint', c: '#8a8d72' },
  mur_chaux: { label: 'Enduit à la chaux', kind: 'paint', c: '#e3d9c9' },
};

export const SLOTS = [
  { id: 'front', label: 'Façades & structure', mats: ['noyer', 'chene_fume', 'chene', 'chene_blanchi', 'chene_cognac', 'ebene', 'teck', 'laque_anthracite', 'laque_blanc', 'laque_lin', 'laque_greige', 'laque_cachemire', 'laque_sauge', 'laque_caramel', 'laque_terracotta', 'vert_foret', 'laque_marine', 'bleu_nuit', 'fenix_noir'] },
  { id: 'accent', label: 'Tiroirs & façades secondaires', mats: ['same', 'laque_greige', 'laque_blanc', 'laque_cachemire', 'laque_sauge', 'laque_anthracite', 'fenix_noir', 'vert_foret', 'noyer', 'chene', 'chene_blanchi', 'calacatta'] },
  { id: 'top', label: 'Plans, pierres & marbres', mats: ['calacatta', 'marbre_creme', 'nero', 'vert_guatemala', 'quartzite', 'travertin', 'terrazzo', 'beton', 'granit', 'fenix_top', 'chene_massif'] },
  { id: 'metal', label: 'Poignées & métal', mats: ['laiton', 'champagne', 'bronze', 'noir_mat', 'inox'] },
  { id: 'floor', label: 'Sol', mats: ['parquet_chene', 'parquet_fume', 'parquet_noir', 'sol_travertin', 'sol_marbre', 'sol_beton', 'deck_teck'] },
  { id: 'wall', label: 'Murs', mats: ['mur_blanc', 'mur_greige', 'mur_chaux', 'mur_terracotta', 'mur_olive', 'mur_anthracite'] },
];

// Collections de façades JENMA (modèle de porte, indépendant du coloris)
export const FACADES = {
  lisse: { label: 'Épure', sub: 'Lisse, poignée métal' },
  cannele: { label: 'Cannelure', sub: 'Cannelée verticale' },
  cadre: { label: 'Atelier', sub: 'Cadre large 5 cm' },
  filet: { label: 'Filet', sub: 'Cadre fin 1 cm' },
  gorge: { label: 'Horizon', sub: 'Sans poignée, à gorge' },
  verre: { label: 'Verrière', sub: 'Cadre métal & verre fumé' },
};

export const PRESETS = [
  { id: 'signature', label: 'Noyer Signature', facade: 'filet', mats: { front: 'noyer', accent: 'laque_greige', top: 'calacatta', metal: 'laiton', floor: 'parquet_noir', wall: 'mur_greige' } },
  { id: 'marbre', label: 'Marbre & Laiton', facade: 'gorge', mats: { front: 'laque_blanc', accent: 'same', top: 'calacatta', metal: 'champagne', floor: 'sol_marbre', wall: 'mur_blanc' } },
  { id: 'mineral', label: 'Minéral Anthracite', facade: 'lisse', mats: { front: 'laque_anthracite', accent: 'same', top: 'nero', metal: 'noir_mat', floor: 'sol_beton', wall: 'mur_anthracite' } },
  { id: 'foret', label: 'Forêt & Bronze', facade: 'cadre', mats: { front: 'vert_foret', accent: 'same', top: 'vert_guatemala', metal: 'bronze', floor: 'parquet_fume', wall: 'mur_chaux' } },
  { id: 'riviera', label: 'Riviera Chêne', facade: 'cannele', mats: { front: 'chene', accent: 'laque_blanc', top: 'travertin', metal: 'laiton', floor: 'sol_travertin', wall: 'mur_blanc' } },
  { id: 'nuit', label: 'Nuit Macassar', facade: 'lisse', mats: { front: 'ebene', accent: 'fenix_noir', top: 'granit', metal: 'champagne', floor: 'parquet_noir', wall: 'mur_anthracite' } },
  { id: 'sauge', label: 'Sauge & Travertin', facade: 'cannele', mats: { front: 'laque_sauge', accent: 'same', top: 'travertin', metal: 'laiton', floor: 'parquet_chene', wall: 'mur_chaux' } },
  { id: 'cachemire', label: 'Cachemire & Terrazzo', facade: 'cadre', mats: { front: 'laque_cachemire', accent: 'same', top: 'terrazzo', metal: 'champagne', floor: 'parquet_chene', wall: 'mur_blanc' } },
];

export const UPPERS = {
  none: { label: 'Aucun' },
  wall: { label: 'Meuble haut', h: 720, d: 350, elev: 1450, parts: [{ k: 'door' }] },
  open: { label: 'Étagères ouvertes', h: 720, d: 300, elev: 1450, parts: [{ k: 'open' }] },
  glass: { label: 'Vitrine haute', h: 720, d: 350, elev: 1450, parts: [{ k: 'glass' }] },
  lift: { label: 'Haut relevant', h: 560, d: 350, elev: 1500, parts: [{ k: 'door' }] },
  hood: { label: 'Hotte habillée', h: 500, d: 450, elev: 1650, parts: [{ k: 'hood' }] },
  mirror: { label: 'Miroir rétroéclairé', h: 900, d: 30, elev: 1150, parts: [{ k: 'mirror' }] },
  shelf: { label: 'Tablette flottante', h: 40, d: 250, elev: 1500, parts: [{ k: 'slab' }] },
};

const base = (o) => ({ zone: 'base', h: 900, d: 600, wMin: 300, wMax: 1200, w: 600, ...o });
const tall = (o) => ({ zone: 'tall', h: 2350, d: 600, wMin: 400, wMax: 1200, w: 600, ...o });
const float = (o) => ({ zone: 'float', elev: 250, h: 550, d: 500, wMin: 600, wMax: 1400, w: 900, ...o });
const free = (o) => ({ zone: 'free', wMin: 600, wMax: 2000, ...o });

export const TYPES = {
  k_base: base({ label: 'Bas 2 portes', w: 800, parts: [{ k: 'drawer', h: 150 }, { k: 'door' }] }),
  k_drawers: base({ label: 'Bas casseroliers', w: 800, parts: [{ k: 'drawer' }, { k: 'drawer' }, { k: 'drawer' }] }),
  k_sink: base({ label: 'Bas évier', w: 900, wMin: 600, top: 'sink', parts: [{ k: 'door' }] }),
  k_hob: base({ label: 'Bas cuisson', w: 900, wMin: 600, top: 'hob', parts: [{ k: 'drawer', h: 200 }, { k: 'drawer' }], upper: 'hood' }),
  k_dish: base({ label: 'Lave-vaisselle intégré', w: 600, wMin: 450, wMax: 600, parts: [{ k: 'door' }] }),
  k_corner: base({ label: "Bas d'angle", w: 1000, wMin: 900, wMax: 1200, parts: [{ k: 'drawer', h: 150 }, { k: 'door' }] }),
  k_spice: base({ label: 'Coulissant épicier', w: 200, wMin: 150, wMax: 300, parts: [{ k: 'drawer', h: 150 }, { k: 'door' }] }),
  k_ovenbase: base({ label: 'Four sous plan', w: 600, wMax: 600, parts: [{ k: 'oven', h: 600 }, { k: 'drawer' }] }),
  k_tallstore: tall({ label: 'Colonne rangement', w: 600, parts: [{ k: 'door', h: 900 }, { k: 'door' }] }),
  k_oven: tall({ label: 'Colonne four & micro-ondes', w: 600, wMax: 700, parts: [{ k: 'door', h: 700 }, { k: 'micro', h: 400 }, { k: 'oven', h: 600 }, { k: 'drawer' }] }),
  k_fridge: tall({ label: 'Colonne réfrigérateur', w: 600, wMax: 900, parts: [{ k: 'door', h: 450 }, { k: 'fridge' }] }),
  k_pantry: tall({ label: 'Colonne garde-manger', w: 600, parts: [{ k: 'door' }] }),
  k_vitrine: tall({ label: 'Vitrine éclairée', w: 600, parts: [{ k: 'glass' }, { k: 'drawer', h: 300 }] }),
  d_hang2: tall({ label: 'Double penderie', w: 900, parts: [{ k: 'open', h: 350 }, { k: 'hang', h: 920 }, { k: 'hang' }] }),
  d_long: tall({ label: 'Penderie longue', w: 800, parts: [{ k: 'open', h: 350 }, { k: 'hangLong' }] }),
  d_mixed: tall({ label: 'Penderie & tiroirs', w: 900, parts: [{ k: 'open', h: 350 }, { k: 'hang', h: 1050 }, { k: 'drawer' }, { k: 'drawer' }] }),
  d_shelves: tall({ label: 'Étagères éclairées', w: 500, wMin: 300, parts: [{ k: 'open' }] }),
  d_shoes: tall({ label: 'Range-chaussures', w: 600, parts: [{ k: 'open', h: 450 }, { k: 'shoes' }] }),
  d_vitrine: tall({ label: 'Vitrine sacs & montres', w: 600, parts: [{ k: 'glass' }, { k: 'drawer', h: 260 }, { k: 'drawer', h: 260 }] }),
  d_vanity: tall({ label: 'Coiffeuse & miroir', w: 1000, wMin: 800, parts: [{ k: 'open', h: 450 }, { k: 'mirror', h: 900 }, { k: 'drawer', h: 160 }, { k: 'void' }] }),
  d_doors: tall({ label: 'Armoire portes pleines', w: 1000, parts: [{ k: 'door' }] }),
  s_vanity: float({ label: 'Meuble vasque', top: 'basin', w: 900, parts: [{ k: 'drawer' }, { k: 'drawer' }], upper: 'mirror' }),
  s_vanity2: float({ label: 'Double vasque', top: 'basin2', w: 1500, wMin: 1200, wMax: 2000, parts: [{ k: 'drawer' }, { k: 'drawer' }], upper: 'mirror' }),
  s_column: { zone: 'float', elev: 250, h: 1650, d: 350, wMin: 300, wMax: 600, w: 400, label: 'Colonne suspendue', parts: [{ k: 'door' }, { k: 'open', h: 380 }] },
  s_shower: free({ label: "Douche à l'italienne", free: 'shower', w: 1200, wMin: 900, wMax: 1800, h: 2200, d: 900 }),
  s_bath: free({ label: 'Baignoire habillée', free: 'bath', w: 1700, wMin: 1500, wMax: 1900, h: 580, d: 780 }),
  s_wc: free({ label: 'WC suspendu', free: 'wc', w: 700, wMin: 600, wMax: 900, h: 1150, d: 550 }),
  b_washer: tall({ label: 'Colonne lave & sèche-linge', w: 650, wMin: 600, wMax: 700, parts: [{ k: 'door', h: 450 }, { k: 'dryer', h: 850 }, { k: 'washer' }] }),
  b_basin: base({ label: 'Bac à laver', w: 700, top: 'sink', parts: [{ k: 'door' }] }),
  b_baskets: base({ label: 'Paniers en osier', w: 600, parts: [{ k: 'basket' }, { k: 'basket' }, { k: 'basket' }] }),
  b_tall: tall({ label: 'Colonne balais', w: 500, wMin: 300, parts: [{ k: 'door' }] }),
  b_drying: tall({ label: 'Étendoir & penderie', w: 800, parts: [{ k: 'open', h: 400 }, { k: 'hang', h: 1000 }, { k: 'basket' }] }),
  r_wine: tall({ label: 'Cave à vin', w: 600, wMax: 1000, parts: [{ k: 'wine' }, { k: 'drawer', h: 250 }] }),
  r_coffee: tall({ label: 'Niche espresso', w: 600, parts: [{ k: 'door', h: 650 }, { k: 'coffee', h: 520 }, { k: 'drawer', h: 260 }, { k: 'drawer' }] }),
  r_spirits: tall({ label: 'Vitrine spiritueux', w: 800, parts: [{ k: 'glass' }, { k: 'door', h: 750 }] }),
  r_base: base({ label: 'Bas bar 2 portes', w: 900, parts: [{ k: 'door' }] }),
  r_tv: tall({ label: 'Mur TV', w: 1800, wMin: 1400, wMax: 2600, parts: [{ k: 'open', h: 450 }, { k: 'tv', h: 900 }, { k: 'open' }, { k: 'drawer', h: 400 }] }),
  books: tall({ label: 'Bibliothèque', w: 900, parts: [{ k: 'books' }, { k: 'door', h: 700 }] }),
  o_desk: free({ label: 'Bureau suspendu', free: 'desk', w: 1600, wMin: 1200, wMax: 2400, h: 750, d: 700 }),
  o_drawers: base({ label: 'Caisson tiroirs', w: 500, wMin: 400, wMax: 800, h: 740, parts: [{ k: 'drawer' }, { k: 'drawer' }, { k: 'drawer' }] }),
  e_bbq: base({ label: 'Barbecue encastré', w: 900, wMin: 700, top: 'bbq', parts: [{ k: 'door' }] }),
  e_plancha: base({ label: 'Plancha', w: 700, wMin: 600, top: 'plancha', parts: [{ k: 'drawer', h: 200 }, { k: 'door' }] }),
  e_fridge: base({ label: 'Réfrigérateur sous plan', w: 600, wMax: 700, parts: [{ k: 'glass' }] }),
  e_logs: base({ label: 'Rangement bûches', w: 600, parts: [{ k: 'logs' }] }),
  e_bench: free({ label: 'Banc béton & bois', free: 'bench', w: 1800, wMin: 1000, wMax: 3000, h: 450, d: 450 }),
  e_planter: free({ label: 'Jardinière végétalisée', free: 'planter', w: 900, wMin: 500, wMax: 2000, h: 650, d: 500 }),
};

export const CATEGORIES = [
  {
    id: 'cuisine', label: 'Cuisine', tagline: 'Îlots sculptés, marbres veinés et niches éclairées',
    room: { w: 4400, h: 2600, d: 4000 }, island: { allowed: true, label: 'Îlot central', w: 2200, d: 1000 },
    uppers: ['none', 'wall', 'lift', 'open', 'glass', 'hood'],
    types: ['k_base', 'k_drawers', 'k_sink', 'k_hob', 'k_dish', 'k_corner', 'k_spice', 'k_ovenbase', 'k_oven', 'k_fridge', 'k_pantry', 'k_tallstore', 'k_vitrine'],
    start: [['k_fridge'], ['k_oven'], ['k_drawers', 'wall'], ['k_hob', 'hood'], ['k_sink', 'open'], ['k_dish', 'wall'], ['k_vitrine']],
    preset: 'sauge', islandOn: true,
  },
  {
    id: 'dressing', label: 'Dressing', tagline: 'Penderies en noyer, éclairage LED et îlot à bijoux',
    room: { w: 4600, h: 2600, d: 3800 }, island: { allowed: true, label: 'Îlot à bijoux', w: 1400, d: 650 },
    uppers: ['none'],
    types: ['d_hang2', 'd_long', 'd_mixed', 'd_shelves', 'd_shoes', 'd_vitrine', 'd_vanity', 'd_doors'],
    start: [['d_mixed'], ['d_shelves'], ['d_hang2'], ['d_shelves'], ['d_mixed'], ['d_shoes']],
    preset: 'signature', islandOn: false,
  },
  {
    id: 'sdb', label: 'Salle de bain & Spa', tagline: 'Pierres naturelles, douche pluie et vasques sculptées',
    room: { w: 4000, h: 2500, d: 3000 }, island: { allowed: false },
    uppers: ['none', 'mirror', 'shelf'],
    types: ['s_vanity', 's_vanity2', 's_column', 's_shower', 's_bath', 's_wc'],
    start: [['s_shower'], ['s_vanity2', 'mirror'], ['s_column'], ['s_wc', 'shelf']],
    preset: 'riviera', islandOn: false,
  },
  {
    id: 'buanderie', label: 'Buanderie', tagline: 'Fonctionnalité optimisée, bois et paniers naturels',
    room: { w: 3200, h: 2500, d: 2200 }, island: { allowed: false },
    uppers: ['none', 'wall', 'open'],
    types: ['b_washer', 'b_basin', 'b_baskets', 'b_tall', 'b_drying', 'k_base'],
    start: [['b_washer'], ['b_basin', 'open'], ['b_baskets', 'wall'], ['b_drying']],
    preset: 'riviera', islandOn: false,
  },
  {
    id: 'bar', label: 'Living Bar & Cave', tagline: 'Cave à vin intégrée, espresso et vitrines éclairées',
    room: { w: 4800, h: 2700, d: 4200 }, island: { allowed: true, label: 'Comptoir de bar', w: 1800, d: 700 },
    uppers: ['none', 'open', 'glass'],
    types: ['r_wine', 'r_coffee', 'r_spirits', 'r_base', 'r_tv', 'books'],
    start: [['r_wine'], ['r_spirits'], ['r_base', 'open'], ['r_coffee'], ['r_wine']],
    preset: 'nuit', islandOn: true,
  },
  {
    id: 'bureau', label: 'Bureau', tagline: 'Espaces de travail fonctionnels et raffinés',
    room: { w: 4200, h: 2600, d: 3600 }, island: { allowed: false },
    uppers: ['none', 'open', 'wall'],
    types: ['books', 'o_desk', 'o_drawers', 'd_doors', 'd_shelves', 'r_tv'],
    start: [['books'], ['o_drawers', 'open'], ['o_desk', 'open'], ['books']],
    preset: 'foret', islandOn: false,
  },
  {
    id: 'exterieur', label: 'Cuisine extérieure & Terrasse', tagline: 'Barbecue, plancha, teck et pierre sous pergola',
    room: { w: 5200, h: 2700, d: 4200 }, island: { allowed: true, label: 'Table haute', w: 2000, d: 900 },
    uppers: ['none', 'shelf'],
    types: ['e_bbq', 'e_plancha', 'k_sink', 'e_fridge', 'e_logs', 'e_bench', 'e_planter'],
    start: [['e_planter'], ['e_logs'], ['e_bbq', 'shelf'], ['e_plancha'], ['k_sink'], ['e_fridge'], ['e_planter']],
    preset: 'mineral', islandOn: true, outdoor: true,
  },
];

export const getCategory = (id) => CATEGORIES.find((c) => c.id === id) || CATEGORIES[0];

let uidCounter = 0;
export const newUid = () => `m${Date.now().toString(36)}${(uidCounter++).toString(36)}`;

export const makeModule = (type, upper) => ({
  uid: newUid(), type, w: TYPES[type].w, upper: upper || TYPES[type].upper || 'none',
});

export const defaultConfig = (catId) => {
  const cat = getCategory(catId);
  const preset = PRESETS.find((p) => p.id === cat.preset);
  const mats = { ...preset.mats };
  if (cat.outdoor) { mats.floor = 'deck_teck'; mats.wall = 'mur_chaux'; mats.front = 'teck'; }
  return {
    category: cat.id,
    room: { ...cat.room },
    modules: cat.start.map(([t, u]) => makeModule(t, u)),
    island: { on: !!cat.islandOn, w: cat.island.w || 1600, d: cat.island.d || 800 },
    mats,
    facade: preset.facade || 'lisse',
    led: true,
    layout: 'I', modulesB: [], modulesC: [],
  };
};

export const matColor = (id) => (MAT[id] ? MAT[id].c : '#999');

export const normalizeConfig = (cfg) => {
  const d = defaultConfig(cfg?.category);
  return { ...d, ...cfg, room: { ...d.room, ...cfg?.room }, island: { ...d.island, ...cfg?.island }, mats: { ...d.mats, ...cfg?.mats }, modules: Array.isArray(cfg?.modules) ? cfg.modules.filter((m) => TYPES[m.type]) : d.modules, modulesB: (cfg?.modulesB || []).filter((m) => TYPES[m.type]), modulesC: (cfg?.modulesC || []).filter((m) => TYPES[m.type]), layout: ['I', 'L', 'U'].includes(cfg?.layout) ? cfg.layout : 'I', facade: FACADES[cfg?.facade] ? cfg.facade : d.facade };
};
